import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import deepEqual from 'deep-equal';
import { resetCriteria2, resetReportObjValues } from './resetUtils';
import { reportAttrsVals, reportAttrsVals_Orig } from './objects';
import { Spin } from 'antd';
import { differenceInDays } from 'date-fns';
import { messageI18n } from '../../../../../../viewer/src/Deepecho/helpers/i18n/toastI18n';
import { useDownloadPDFMutation } from '../../../../../../viewer/src/Deepecho/helpers/api/reports/reports';
import {
  handleACChange_cent,
  handleACChange_ga,
  handleACChange_val,
  handleAFPChange_curr,
  handleAFPChange_prev,
  handleAgeChange,
  handleBPDChange_cent,
  handleBPDChange_ga,
  handleBPDChange_val,
  handleCommentsChange,
  handleDOBChange,
  handleEFAChange_cent,
  handleEFAChange_curr,
  handleEFAChange_prev,
  handleEGAChange_cent,
  handleEGAChange_curr,
  handleEGAChange_prev,
  handleExamChange,
  handleFLChange_cent,
  handleFLChange_ga,
  handleFLChange_val,
  handleGAChange,
  handleGRSChange_curr,
  handleGRSChange_prev,
  handleHCChange_cent,
  handleHCChange_ga,
  handleHCChange_val,
  handleLMPChange,
  handleMSChange,
  handleRHPChange,
  handleSDPChange_cent,
  handleSDPChange_ga,
  handleSDPChange_val,
} from './changeInputsUtils';
import { useNavigate } from 'react-router';
import ActionsBar from './actionsBar';
import ReportHeader from './ReportHeader';
import ReportPlane from './reportPlane';
import GeneralInfo from './generalInfo.tsx';
import ExaminationResults from './examinationResults';
import ExaminationDetails from './examinationDetails';

import { finishReport } from '../../../../../../viewer/src/Deepecho/helpers/backendHelper';
// import { useGetGlobalReportByStudyId } from 'platform/viewer/src/Deepecho/helpers/api/report/report.api';
import {
  useGetGlobalReportByStudyId,
  useUpdateStateReports,
} from '../../../../../../viewer/src/Deepecho/helpers/api/reports/reports';
import { MedicalReport } from './interface';
import { useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useEditPatient } from '../../../../../../viewer/src/Deepecho/helpers/api/patients/patients';
import AiAcceleratorTemp from './aiAcceleratorTemp';
// import Modal from '../../../Modal';
import Modal from '../../../../../../viewer/src/Deepecho/UI/Components/modal';
import ReportCard from './reportCard';
import { MdOutlineGridView } from 'react-icons/md';
interface ReportProps {
  StudyUID: string;
  ohifViewer: boolean;
  aiAccelerate: boolean;
  isOpen: boolean;
  onClose: () => void;
  blind?: JSX.Element;
}
interface GestationalAgeResult {
  gestationalAgeWeeks: number | null;
  gestationalAgeDays: number | null;
  totalWeeksDecimal?: number | null;
  examinationDate?: Date | null;
  estimatedDueDate?: Date | null;
}

interface Study {
  study_instance_uid: string;
  comment: string | null;
  created_at: string;
  updated_at: string | null;
  is_completed?: boolean;
  report_content?: object;
  study: {
    study_instance_uid: string;
    study_date: string;
    study_mode: string;
    study_type: string;
  };
  patient: {
    id: string;
    patient_name: string;
    patient_last_name: string;
    birth_date: string | null;
    last_menstrual_period: string | null;
  };
  user: {
    id: string;
    first_name: string;
    last_name: string;
  };
}

interface ReportData {
  data?: {
    views: Array<{
      frame_id: string;
      frame_number: number;
      view_code: string;
      display_name: string;
      view_def_id: number;
      quality_flags: Array<{
        flag_code: string;
        display_name: string;
        value: boolean;
      }>;
      measurements: Array<{
        id: string;
        meas_name: string;
        value: number;
      }>;
      image_base64: string;
    }>;
    report: Study;
  };
}

const Report: React.FC<ReportProps> = ({
  StudyUID,
  ohifViewer,
  aiAccelerate,
  isOpen,
  onClose,
  blind
}) => {
  // let StudyUID = new URLSearchParams(location.search).get('StudyInstanceUIDs');

  const { isLoading, data, error } = useGetGlobalReportByStudyId(StudyUID, [
    `globalReportData/${StudyUID}`,
  ]) as { isLoading: boolean; data: ReportData | undefined; error: unknown };
  console.log('/*/*/*data/*/*/*', data);
  const [reportCards, setReportCards] = useState<
    Array<{
      id: string;
      label: string;
      plan: string;
      imageUrl: string;
      qualityMetrics: Record<string, boolean>;
      measurements: Array<{ name: string; value: number }>;
    }>
  >([]);

  const [examData, setExamData] = useState(reportAttrsVals);
  const [reportDetails, setReportDetails] = useState<
    ReportData['data'] | undefined
  >(undefined);
  const [editMode, setEditMode] = useState(false);
  const [resetActive, setResetActive] = useState(false);
  const [finished, setFinished] = useState(
    data?.data?.report?.is_completed ?? false
  );
  const [loadingFinished, setLoadingFinished] = useState(false);

  const [calculatedGa, setCalculatedGa] = useState<GestationalAgeResult>({
    gestationalAgeWeeks: null,
    gestationalAgeDays: null,
    totalWeeksDecimal: null,
  });
  const [Ga, setGa] = useState<GestationalAgeResult>({
    gestationalAgeWeeks: 0,
    gestationalAgeDays: 0,
  });

  // Plan 1
  const [selectedFrame1ID, setSelectedFrame1ID] = useState(0);

  // Plan 2
  const [selectedFrame2ID, setSelectedFrame2ID] = useState(0);

  // Plan 2
  const [selectedFrame3ID, setSelectedFrame3ID] = useState(0);
  const [selectedFramePlan3, setSelectedFramePlan3] = useState({});
  // Plan 3
  const [selectedFrame4ID, setSelectedFrame4ID] = useState(0);

  const timestamp = Date.now();
  const currentDate = new Date(timestamp);
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');
  const formattedDate = `${year}/${month}/${day}`;

  const [LMP, setLMP] = useState(null);
  const queryClient = useQueryClient();
  // Add these state variables at the component level
  const [isUpdatingBoth, setIsUpdatingBoth] = useState(false);
  const [patientUpdated, setPatientUpdated] = useState(false);
  const [reportUpdated, setReportUpdated] = useState(false);

  // Get existing frame view IDs from global report
  const existingFrameViewIds = React.useMemo(() => {
    if (!data?.data?.views) {
      return [];
    }
    return data.data.views.map((view) => view.frame_id);
  }, [data]);

  const onSuccessReport = (response: AxiosResponse, data: any) => {
    if (response) {
      setReportUpdated(true);
      // Only refetch if we're not updating both
      if (!isUpdatingBoth) {
        refetchQueries();
      }
      setEditMode(false);
    }
  };

  const onErrorReport = (error: any, data: Error) => {
    console.log('error:', error);
    messageI18n.error('report.errorUpdateStudy');
    setEditMode(false);
  };

  const onSuccessPatient = (response: AxiosResponse, data: any) => {
    setPatientUpdated(true);
    // Only refetch if we're not updating both
    if (!isUpdatingBoth) {
      refetchQueries();
    }
  };

  const onErrorPatient = (error: any, data: Error) => {
    messageI18n.error('report.errorUpdatePatient');
    setEditMode(false);
  };

  // Helper function to refetch all relevant queries
  const refetchQueries = () => {
    queryClient.refetchQueries({
      queryKey: [`/study_report/${reportDetails?.report?.study_instance_uid}`],
    });
    // queryClient.refetchQueries({
    //   queryKey: [
    //     `/study_report/report/${reportDetails?.report?.study_instance_uid}`,
    //   ],
    // });
  };

  const muttationUpdateReport = useUpdateStateReports(
    onSuccessReport,
    onErrorReport
  );
  const muttationUpdatePatient = useEditPatient(
    onSuccessPatient,
    onErrorPatient
  );

  const handlEditReport = async () => {
    // Reset state
    setIsUpdatingBoth(false);
    setPatientUpdated(false);
    setReportUpdated(false);

    const lastMenstrualPeriod =
      reportDetails?.report?.patient?.last_menstrual_period;
    const lmp = LMP;

    const lmpDate = new Date(lmp);
    const lastMenstrualPeriodDate = new Date(lastMenstrualPeriod);

    const datesAreDifferent =
      lmpDate.getFullYear() !== lastMenstrualPeriodDate.getFullYear() ||
      lmpDate.getMonth() !== lastMenstrualPeriodDate.getMonth() ||
      lmpDate.getDate() !== lastMenstrualPeriodDate.getDate();

    const isReportContentDifferent =
      JSON.stringify(reportDetails?.report?.report_content) !==
      JSON.stringify(data?.data?.report?.report_content);
    const isCommentDifferent =
      reportDetails?.report?.comment !== data?.data?.report?.comment;

    // Set flag if we're updating both
    if (datesAreDifferent && (isReportContentDifferent || isCommentDifferent)) {
      setIsUpdatingBoth(true);
    }

    try {
      if (datesAreDifferent) {
        await muttationUpdatePatient.mutateAsync({
          patient_id: reportDetails?.report?.patient?.id,
          values: {
            last_menstrual_period: LMP?.length > 0 ? LMP : null,
            patient_name: reportDetails?.report?.patient?.patient_name,
            patient_last_name:
              reportDetails?.report?.patient?.patient_last_name,
            birth_date: reportDetails?.report?.patient?.birth_date,
          },
        });
        setEditMode(false);
      }

      if (isReportContentDifferent || isCommentDifferent) {
        const updatedData = {
          study_instance_uid: reportDetails?.report?.study_instance_uid,
          report_content: reportDetails?.report?.report_content,
          comment: reportDetails?.report?.comment,
        };
        await muttationUpdateReport.mutateAsync(updatedData);
        setEditMode(false);
      }

      // If both updates were needed and both succeeded, do a single refetch
      if (isUpdatingBoth && patientUpdated && reportUpdated) {
        refetchQueries();
      }

      // If no changes were made at all
      if (
        !datesAreDifferent &&
        !isReportContentDifferent &&
        !isCommentDifferent
      ) {
        setEditMode(false);
        messageI18n.info('report.noChangesDetected');
      }
    } catch (error) {
      console.log('Failed to update:', error);
      messageI18n.error('report.errorUpdatingData');
      setEditMode(false);
    }
  };

  const handleSwitchChange = () => {
    setEditMode(!editMode);
  };

 const onSuccessUpload = (blob: Blob, data: any) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ultrasound_report.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  const onErrorUpload = (error: any, data: any) => {
    console.log('Error downloading PDF:', error, data);
  };

  const { mutate, isPending: UploadPending } = useDownloadPDFMutation(
    onSuccessUpload,
    onErrorUpload
  );

  console.log('UploadPending', UploadPending);

  const downloadPDF = async () => {
    mutate(reportDetails?.report?.study_instance_uid);
  };

  const saveReport = () => {
    setLoadingFinished(true);
    finishReport(StudyUID)
      .then((res) => {
        setFinished(true);
        setLoadingFinished(false);
        console.log('Report finished', res);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (!deepEqual(examData, reportAttrsVals_Orig)) {
      setResetActive(true);
    }
  }, [examData]);

  useEffect(() => {
    if (data?.data) {
      // Reset state before setting new data
      setReportCards([]);
      setExamData(reportAttrsVals);
      setReportDetails(undefined);
      setCalculatedGa({
        gestationalAgeWeeks: null,
        gestationalAgeDays: null,
        totalWeeksDecimal: null,
      });
      setGa({
        gestationalAgeWeeks: 0,
        gestationalAgeDays: 0,
      });
      setSelectedFrame1ID(0);
      setSelectedFrame2ID(0);
      setSelectedFrame3ID(0);
      setSelectedFrame4ID(0);
      setSelectedFramePlan3({});
      setLMP(null);
      setIsUpdatingBoth(false);
      setPatientUpdated(false);
      setReportUpdated(false);
      setEditMode(false);
      setResetActive(false);
      setFinished(false);
      setLoadingFinished(false);

      // Then set new data
      setReportDetails(data.data);
      setLMP(data.data.report?.patient?.last_menstrual_period);
    }
  }, [data, StudyUID]); // Add StudyUID as dependency

  // Add cleanup effect
  useEffect(() => {
    return () => {
      // Cleanup when component unmounts or StudyUID changes
      setReportCards([]);
      setExamData(reportAttrsVals);
      setReportDetails(undefined);
      setCalculatedGa({
        gestationalAgeWeeks: null,
        gestationalAgeDays: null,
        totalWeeksDecimal: null,
      });
      setGa({
        gestationalAgeWeeks: 0,
        gestationalAgeDays: 0,
      });
      setSelectedFrame1ID(0);
      setSelectedFrame2ID(0);
      setSelectedFrame3ID(0);
      setSelectedFrame4ID(0);
      setSelectedFramePlan3({});
      setLMP(null);
      setIsUpdatingBoth(false);
      setPatientUpdated(false);
      setReportUpdated(false);
      setEditMode(false);
      setResetActive(false);
      setFinished(false);
      setLoadingFinished(false);
      // Remove setMode(false) to maintain aiAccelerate state
      // setMode(false);

      // Clean up TanStack Query cache
      queryClient.removeQueries({
        queryKey: [`globalReportData/${StudyUID}`],
      });
      queryClient.removeQueries({
        queryKey: [`/study_report/${StudyUID}`],
      });
      // queryClient.removeQueries({
      //   queryKey: [`report_views/${StudyUID}`],
      // });
      // queryClient.removeQueries({
      //   queryKey: ['report'],
      // });
    };
  }, [StudyUID, queryClient]); // Add queryClient as dependency

  const generateReportCards = (dataSource: ReportData | undefined) => {
    if (!dataSource?.data?.views) return [];

    return dataSource.data.views.map((view) => {
      const displayLabel = view.view_code.startsWith('VIEW__')
        ? view.view_code.replace('VIEW__', '')
        : view.view_code;

      const formattedLabel =
        displayLabel.charAt(0).toUpperCase() +
        displayLabel.slice(1).replace(/_/g, ' ');

      return {
        id: view.frame_id,
        label: formattedLabel,
        plan: view.view_code,
        imageUrl: view.image_base64,
        qualityMetrics: view?.quality_flags?.reduce(
          (acc, flag) => {
            acc[flag.flag_code] = flag.value;
            return acc;
          },
          {} as Record<string, boolean>
        ),
        measurements: view.measurements.map((meas) => ({
          name: meas.meas_name,
          value: meas.value,
        })),
      };
    });
  };

  useEffect(() => {
    const cards = generateReportCards(data);
    setReportCards(cards);
  }, [data]);

  const handleCardDelete = (planToDelete) => {
    // Update the reportCards state by filtering out the deleted card
    setReportCards(reportCards.filter((card) => card.plan !== planToDelete));
  };

  const reset = () => {
    if (data?.data) {
      setReportDetails(data.data);
      setLMP(data.data.report?.patient?.last_menstrual_period);
      const resetCards = generateReportCards(data);
      setReportCards(resetCards);
    }
  };
  function calculateCentile(measurement_cm, gestational_age, centileTable) {
    if (!gestational_age) {
      return '***';
    }
    const measurement = measurement_cm * 10;
    if (!measurement) {
      return '***';
    }

    const row = centileTable['' + Math.floor(gestational_age)];

    if (!_.isEmpty(row)) {
      const centile3rd = row['3rd'];
      const centile5th = row['5th'];
      const centile10th = row['10th'];
      const centile50th = row['50th'];
      const centile90th = row['90th'];
      const centile95th = row['95th'];
      const centile97th = row['97th'];

      if (measurement < centile3rd) {
        return 'Below 3rd Centile';
      } else if (centile3rd <= measurement && measurement < centile5th) {
        return 'Between 3rd and 5th Centile';
      } else if (centile5th <= measurement && measurement < centile10th) {
        return 'Between 5th and 10th Centile';
      } else if (centile10th <= measurement && measurement < centile50th) {
        return 'Between 10th and 50th Centile';
      } else if (centile50th <= measurement && measurement < centile90th) {
        return 'Between 50th and 90th Centile';
      } else if (centile90th <= measurement && measurement < centile95th) {
        return 'Between 90th and 95th Centile';
      } else if (centile95th <= measurement && measurement < centile97th) {
        return 'Between 95th and 97th Centile';
      } else {
        return 'Above 95th Centile';
      }
    } else {
      return '***';
    }
  }
  function calculateGestationalAge(lmpDate) {
    try {
      if (!lmpDate) {
        return JSON.stringify({});
      }
      const lmp = new Date(lmpDate);
      const today = new Date();
      let gestationalAge = differenceInDays(today, lmp);
      console.log('gestationalAge 44', gestationalAge);

      if (gestationalAge < 0) {
        return JSON.stringify({
          gestationalAgeWeeks: 0,
          gestationalAgeDays: 0,
        });
      } else {
        let weeks = Math.floor(gestationalAge / 7);
        let days = gestationalAge % 7;
        console.log('gestationalAge 55', weeks, days);
        if (weeks === 0) {
          return JSON.stringify({
            gestationalAgeWeeks: 0,
            gestationalAgeDays: days,
          });
        }
        if (days === 0) {
          return JSON.stringify({
            gestationalAgeWeeks: weeks,
            gestationalAgeDays: 0,
          });
        }
        return JSON.stringify({
          gestationalAgeWeeks: weeks,
          gestationalAgeDays: days,
        });
      }
    } catch (error) {
      return JSON.stringify({
        gestationalAgeWeeks: 0,
        gestationalAgeDays: 0,
      });
    }
  }

  function onCloseModal() {
    // Don't reset mode here since we want to maintain it
    setEditMode(false);
    setResetActive(false);
    setFinished(false);
    setLoadingFinished(false);
    setReportCards([]);
    setExamData(reportAttrsVals);
    setReportDetails(undefined);
    setCalculatedGa({
      gestationalAgeWeeks: null,
      gestationalAgeDays: null,
      totalWeeksDecimal: null,
    });
    setGa({
      gestationalAgeWeeks: 0,
      gestationalAgeDays: 0,
    });
    setSelectedFrame1ID(0);
    setSelectedFrame2ID(0);
    setSelectedFrame3ID(0);
    setSelectedFrame4ID(0);
    setSelectedFramePlan3({});
    setLMP(null);
    setIsUpdatingBoth(false);
    setPatientUpdated(false);
    setReportUpdated(false);

    // Invalidate queries to ensure fresh data on reopen
    queryClient.invalidateQueries({
      queryKey: ['globalReportData'],
    });
    queryClient.invalidateQueries({
      queryKey: [`/study_report/${StudyUID}`],
    });
    queryClient.invalidateQueries({
      queryKey: [`/study_report/views/${StudyUID}`],
    });

    onClose();
  }

  useEffect(() => {
    const a = calculateGestationalAge(LMP);
    setGa(JSON.parse(a));
  }, [LMP]);
  return (
    <div className={`fixed inset-0 z-30 ${isOpen ? 'visible' : 'hidden'}`}>
      <Modal
        isOpen={isOpen}
        onClose={onCloseModal}
        size="fullScreen"
        overlayClassName="py-10"
        className="bg-card-color-200 flex flex-col h-full"
      >
        <Modal.Header
          className="px-0 py-0 flex-shrink-0"
          title={
            <ReportHeader
              study={reportDetails?.report}
              saveReport={saveReport}
              resetReportObjValues={() =>
                resetReportObjValues(setExamData, examData, setResetActive)
              }
              setExamData={setExamData}
              examData={examData}
              setResetActive={setResetActive}
              resetActive={resetActive}
              downloadPDF={downloadPDF}
              editMode={editMode}
              finishMode={data?.data?.report?.is_completed}
              finished={finished}
              data={data?.data}
              setReportDetails={setReportDetails}
              ohifViewer={ohifViewer}
              loadingFinished={loadingFinished}
              handlEditReport={handlEditReport}
              handleSwitchChange={handleSwitchChange}
              UploadPending={UploadPending}
              aiAccelerate={aiAccelerate}
              reset={reset}
            />
          }
          onClose={onClose}
          displayClose={false}
        />


        {reportDetails &&
          !isLoading &&
          Object.keys(reportDetails).length !== 0 ? (
          <Modal.Content classContent="px-0 flex-1 min-h-0">
            <div
              id="modalContent"
              className="actual-receipt flex h-full flex-col bg-card-color-100"
            >
              <div className="w-full flex-1 min-h-0">
                <div className="flex flex-col lg:flex-row w-full h-full min-h-0">
                  <div className="flex h-full w-full flex-col-reverse xl:grid xl:grid-cols-2 xl:gap-3 min-h-0">
                    {/* Report Planes Container */}
                    <div className="flex min-h-0 flex-col space-y-2 xl:min-h-0">
                      {reportCards.length === 0 ? (
                        <div className="flex h-full justify-center items-center flex-col space-y-2">
                          <MdOutlineGridView className="w-16 h-16 mb-4 text-gray-400" />
                          <p className="text-lg font-semibold">
                            No views detected yet
                          </p>
                          <p className="text-sm">
                            Please generate a report view to continue.
                          </p>
                        </div>
                      ) : (
                        <div className="grid h-full w-full flex-1 grid-cols-2 gap-3 overflow-y-auto pr-4 min-h-0">
                          {reportCards.map((card) => (
                            <div key={card.id} className="flex flex-col">
                              <ReportCard
                                label={card.label}
                                imageUrl={card.imageUrl}
                                qualityMetrics={card.qualityMetrics}
                                isInReport={true}
                                editMode={editMode}
                                reportDetails={reportDetails}
                                setReportDetails={setReportDetails}
                                plan={card.plan}
                                onCardDelete={handleCardDelete}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Report Sidebar */}
                    <div className="h-full w-full min-h-0 overflow-y-auto">
                      <div className="flex flex-col space-y-4 p-4">
                        <GeneralInfo
                          editMode={editMode}
                          examData={examData}
                          study={reportDetails?.report?.patient}
                          setLMP={setLMP}
                          LMP={LMP}
                          calculateGestationalAge={calculateGestationalAge}
                          formattedDate={formattedDate}
                          handleDOBChange={handleDOBChange}
                          setExamData={setExamData}
                          handleAgeChange={handleAgeChange}
                          handleLMPChange={handleLMPChange}
                          handleGAChange={handleGAChange}
                          handleExamChange={handleExamChange}
                          handleMSChange={handleMSChange}
                          handleRHPChange={handleRHPChange}
                        />

                        <ExaminationResults
                          reportDetails={reportDetails?.report}
                          setReportDetails={(details) =>
                            setReportDetails((prev) =>
                              prev ? { ...prev, report: details } : undefined
                            )
                          }
                          keys_info={reportDetails?.report?.report_content}
                          calculateCentile={calculateCentile}
                          setCalculatedGa={setCalculatedGa}
                          calculatedGa={calculatedGa}
                          Ga={Ga}
                          selectedFrame1ID={selectedFrame1ID}
                          selectedFrame2ID={selectedFrame2ID}
                          selectedFrame3ID={selectedFrame3ID}
                          selectedFrame4ID={selectedFrame4ID}
                          editMode={editMode}
                          examData={examData}
                          setExamData={setExamData}
                          handleEGAChange_curr={handleEGAChange_curr}
                          handleEGAChange_prev={handleEGAChange_prev}
                          handleEGAChange_cent={handleEGAChange_cent}
                          handleEFAChange_curr={handleEFAChange_curr}
                          handleEFAChange_prev={handleEFAChange_prev}
                          handleEFAChange_cent={handleEFAChange_cent}
                          handleGRSChange_curr={handleGRSChange_curr}
                          handleGRSChange_prev={handleGRSChange_prev}
                          handleAFPChange_curr={handleAFPChange_curr}
                          handleAFPChange_prev={handleAFPChange_prev}
                          handleCommentsChange={handleCommentsChange}
                          data={data}
                        />

                        {/* {selectedFramePlan3 && (
                          <ExaminationDetails
                            reportDetails={reportDetails?.report}
                            keys_info={reportDetails?.report?.report_content}
                            calculatedGa={calculatedGa}
                            calculateCentile={calculateCentile}
                            Ga={Ga}
                            data={data}
                          />
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Content>
        ) : (
          <div className="flex h-full items-center justify-center">
            <div className="mx-auto align-middle">
              <Spin className="h-18" />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Report;
